import React, {Component} from 'react'
import {Dropdown} from 'semantic-ui-react'

class ChinaLogisticDropdown extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {}
  }

  render() {
    let {isAuthenticated, user, menuOpen, setMenuOpen, Nav} = this.props

    if (isAuthenticated && user) {
      return (
        <span
          onMouseOver={(e) => setMenuOpen(true)}
          onMouseOut={(e) => setMenuOpen(false)}
          style={{marginLeft: '100px'}}
        >
          <Dropdown
            item
            as={Nav}
            open={menuOpen}
            icon=''
            to="/container-import"
            name="container-import"
            text="Container Import"
            style={{background: 'transparent'}}
          >
          </Dropdown>
        </span>
      )
    } else {
      return null
    }
  }
}

export default ChinaLogisticDropdown
